/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9.5 10C9.5 10.2761 9.27614 10.5 9 10.5C8.72386 10.5 8.5 10.2761 8.5 10M9.5 10C9.5 9.72386 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.72386 8.5 10M9.5 10H8.5M15.5 10C15.5 10.2761 15.2761 10.5 15 10.5C14.7239 10.5 14.5 10.2761 14.5 10M15.5 10C15.5 9.72386 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.72386 14.5 10M15.5 10H14.5M16.0002 16C15.088 14.7856 13.6357 14 11.9999 14C10.3641 14 8.91172 14.7856 7.99951 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17 3.33782C15.5291 2.48697 13.8214 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.96818 21.394 8.0779 20.353 6.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="10"
				fill="currentColor"
			/>
			<path
				d="M9.5 10C9.5 10.2761 9.27614 10.5 9 10.5C8.72386 10.5 8.5 10.2761 8.5 10M9.5 10C9.5 9.72386 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.72386 8.5 10M9.5 10H8.5M15.5 10C15.5 10.2761 15.2761 10.5 15 10.5C14.7239 10.5 14.5 10.2761 14.5 10M15.5 10C15.5 9.72386 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.72386 14.5 10M15.5 10H14.5M16.0002 16C15.088 14.7856 13.6357 14 11.9999 14C10.3641 14 8.91172 14.7856 7.99951 16M12 22V22C17.5228 22 22 17.5228 22 12V12C22 6.47715 17.5228 2 12 2V2C6.47715 2 2 6.47715 2 12V12C2 17.5228 6.47715 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM9 8.75C8.30964 8.75 7.75 9.30964 7.75 10C7.75 10.6904 8.30964 11.25 9 11.25C9.69036 11.25 10.25 10.6904 10.25 10C10.25 9.30964 9.69036 8.75 9 8.75ZM15 8.75C14.3096 8.75 13.75 9.30964 13.75 10C13.75 10.6904 14.3096 11.25 15 11.25C15.6904 11.25 16.25 10.6904 16.25 10C16.25 9.30964 15.6904 8.75 15 8.75ZM11.9999 13.25C10.1182 13.25 8.4476 14.1546 7.39984 15.5496C7.15107 15.8808 7.21789 16.3509 7.54908 16.5997C7.88027 16.8484 8.35042 16.7816 8.59919 16.4504C9.37583 15.4165 10.6099 14.75 11.9999 14.75C13.3898 14.75 14.6239 15.4165 15.4006 16.4504C15.6493 16.7816 16.1195 16.8484 16.4507 16.5997C16.7819 16.3509 16.8487 15.8808 16.5999 15.5496C15.5522 14.1546 13.8816 13.25 11.9999 13.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 10C9.5 10.2761 9.27614 10.5 9 10.5C8.72386 10.5 8.5 10.2761 8.5 10M9.5 10C9.5 9.72386 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.72386 8.5 10M9.5 10H8.5M15.5 10C15.5 10.2761 15.2761 10.5 15 10.5C14.7239 10.5 14.5 10.2761 14.5 10M15.5 10C15.5 9.72386 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.72386 14.5 10M15.5 10H14.5M16.0002 16C15.088 14.7856 13.6357 14 11.9999 14C10.3641 14 8.91172 14.7856 7.99951 16M17 3.33782C15.5291 2.48697 13.8214 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.96818 21.394 8.0779 20.353 6.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9.5 10C9.5 10.2761 9.27614 10.5 9 10.5C8.72386 10.5 8.5 10.2761 8.5 10M9.5 10C9.5 9.72386 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.72386 8.5 10M9.5 10H8.5M15.5 10C15.5 10.2761 15.2761 10.5 15 10.5C14.7239 10.5 14.5 10.2761 14.5 10M15.5 10C15.5 9.72386 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.72386 14.5 10M15.5 10H14.5M16.0002 16C15.088 14.7856 13.6357 14 11.9999 14C10.3641 14 8.91172 14.7856 7.99951 16M12 22V22C17.5228 22 22 17.5228 22 12V12C22 6.47715 17.5228 2 12 2V2C6.47715 2 2 6.47715 2 12V12C2 17.5228 6.47715 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.74998 10C7.74998 9.30964 8.30963 8.75 8.99998 8.75C9.69034 8.75 10.25 9.30964 10.25 10C10.25 10.6904 9.69034 11.25 8.99998 11.25C8.30963 11.25 7.74998 10.6904 7.74998 10ZM13.75 10C13.75 9.30964 14.3096 8.75 15 8.75C15.6903 8.75 16.25 9.30964 16.25 10C16.25 10.6904 15.6903 11.25 15 11.25C14.3096 11.25 13.75 10.6904 13.75 10ZM7.39982 15.5496C8.44759 14.1546 10.1182 13.25 11.9999 13.25C13.8815 13.25 15.5521 14.1546 16.5999 15.5496C16.8487 15.8808 16.7819 16.3509 16.4507 16.5997C16.1195 16.8484 15.6493 16.7816 15.4006 16.4504C14.6239 15.4165 13.3898 14.75 11.9999 14.75C10.6099 14.75 9.37582 15.4165 8.59917 16.4504C8.3504 16.7816 7.88025 16.8484 7.54906 16.5997C7.21787 16.3509 7.15105 15.8808 7.39982 15.5496Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
